import { throttle } from "../utils";

const cSideMenu = (componentClass) => {
  const block = document.querySelector(componentClass);
  const contentBlock = block?.querySelector(`${componentClass}__content`);
  const sideMenuContent = block?.querySelector(".side-menu__list");

  const navigation = [];

  const classes = {
    sideMenu: "side-menu__item",
    activeSideMenu: "side-menu__item_active",
  };
  
  if (!block) return null

  window.addEventListener("scroll", throttle(scrollEvent, 100));

  replaceContent();
  generateSideMenuItems();

  function replaceContent() {
    if (contentBlock) {
      contentBlock.innerHTML = contentBlock.outerHTML.replace(
        /<h3[^>]*>([\s\S]*?)<\/h3>/g,
        (val, key) => {
          const text = val
            .replace(/(<style[\w\W]+style>)/g, "")
            .replace(/(<([^>]+)>)/gi, "");

          const link = text
            .toLocaleLowerCase()
            .split(" ")
            .join("-")
            .trim()
            .replace(/[^a-zа-яё0-9\s]/gi, "");

          navigation.push({
            text,
            link,
          });

          return val.replace(/<h3[^>]*>/g, `<h3 id="${link}">`);
        }
      );
    }
  }

  function generateSideMenuItems() {
    if (sideMenuContent && navigation.length) {
      const menuItems = navigation.map((item) => {
        return `
            <a href="#${item.link}" class="side-menu__item">
              <span class="side-menu__itemIcon">
                <svg width="64" height="14" viewBox="0 0 64 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1137_4402)">
                    <path
                        d="M64.0001 2.11853C63.8054 2.66872 63.5402 3.19138 63.2112 3.67347C56.1352 11.7411 47.4366 15.6171 36.7549 12.9805C31.9068 11.6324 27.1307 10.0378 22.4451 8.203C18.0958 6.603 13.6338 5.18333 9.03665 6.35516C5.93324 7.41339 2.91902 8.717 0.0225618 10.2537C0.0194482 9.90531 0.0884262 9.56007 0.225302 9.23967C4.50699 3.13263 10.9746 -2.02796 20.507 0.83401C23.5006 1.80741 26.4418 2.9357 29.3183 4.21429C40.5859 8.92415 51.8535 9.26217 62.5352 2.29878C62.7595 2.15453 63.002 2.04087 63.2564 1.96077C63.4141 1.9157 63.5944 2.02839 64.0001 2.11853Z"
                        fill="currentColor"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1137_4402">
                      <rect width="64" height="13.7915" fill="currentColor"/>
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <p>${item.text}</p>
            </a>
          `;
      });

      sideMenuContent.innerHTML = menuItems.join("");
    }
  }

  function scrollEvent(e) {
    const links = sideMenuContent.querySelectorAll(`.${classes.sideMenu}`);
    const sections = contentBlock.querySelectorAll("h3");
    let index = sections.length;

    if (sections.length === 0) return null;

    function setActiveLink(key) {
      if (links[key]) {
        links.forEach((link) => link.classList.remove(classes.activeSideMenu));
        links[key].classList.add(classes.activeSideMenu);
      }
    }

    setActiveLink(sections.length - 1);

    while (
      --index &&
      window.scrollY <= sections[index].offsetTop + block.offsetTop - 80
    ) {
      if (sections[index].offsetTop + block.offsetTop - 80 >= window.scrollY) {
        setActiveLink(index - 1);
      }
    }
  }
};

export default cSideMenu;
